import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
 apiKey: "AIzaSyD__AOgRqagPM7X77v-PKe7fs6bX3rYkFY",
  authDomain: "botervue-system.firebaseapp.com",
  projectId: "botervue-system",
  storageBucket: "botervue-system.firebasestorage.app",
  messagingSenderId: "445574514223",
  appId: "1:445574514223:web:6263fd8140f246d37328da",
  measurementId: "G-HEEK43G1N8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
